{
  "slug": "bill-gates-iq",
  "title": "Bill Gates IQ: what is actually known?",
  "description": "A careful review of reported Bill Gates IQ claims and why popular numbers are unverified.",
  "category": "Famous people and IQ claims",
  "sections": [
    {
      "heading": "Documented achievement",
      "paragraphs": [
        "Gates co-founded Microsoft and has a documented history in software and philanthropy. Success cannot be converted reliably into IQ points.",
        "Achievement can involve knowledge, persistence, creativity, collaboration, opportunity, and specialist expertise. It cannot be translated into a unique IQ number."
      ]
    },
    {
      "heading": "Evidence behind the reported number",
      "paragraphs": [
        "Claims based on admissions tests or anecdotes confuse constructs, norm groups, and purposes. No authenticated clinical IQ report is publicly established.",
        "A credible claim would identify the instrument, version, date, administration conditions, norm group, score type, and a reliable primary record. Viral lists rarely provide that chain."
      ]
    },
    {
      "heading": "Responsible conclusion",
      "paragraphs": [
        "Treat a number as unverified unless a primary record is available. Separate admiration for achievement from psychometric measurement.",
        "The conclusion is not that the person lacked ability; it is that the precise number is unknown."
      ]
    }
  ],
  "related": ["what-is-iq", "how-is-iq-measured", "iq-vs-intelligence"],
  "sources": [
    {
      "label": "Gates Notes — biography",
      "url": "https://www.gatesnotes.com/bio"
    }
  ],
  "faqs": [
    {
      "question": "What was Bill Gates’s IQ?",
      "answer": "No authenticated standardized score is publicly established. Precise values repeated online should be treated as speculation."
    },
    {
      "question": "Can achievement be converted into IQ?",
      "answer": "No. Achievement and test performance overlap only partly and use different evidence."
    }
  ],
  "summary": "A careful review of reported Bill Gates IQ claims and why popular numbers are unverified. Content reviewed 18 July 2026."
}
